import React, { createContext, useContext } from 'react';

interface DragState {
  activeFieldId: string | null;
  activeSourceContainer: string | null;
  overContainerId: string | null;
  insertIndex: number;
}

const FieldMappingDndContext = createContext<DragState>({
  activeFieldId: null,
  activeSourceContainer: null,
  overContainerId: null,
  insertIndex: -1,
});

export const useFieldMappingDnd = () => useContext(FieldMappingDndContext);

export const FieldMappingDndContextProvider = FieldMappingDndContext.Provider;
